/**
 * A time on a till reads as a clock, not a timestamp.
 *
 * The billing screen reports on one day, so "09:12" is the whole answer for
 * almost every row and the date in front of it is noise. The exception is the
 * row that crossed midnight — a late table, an overnight shift — where the date
 * is exactly the fact being asked about, so that one keeps the full stamp.
 */
import { formatDateTime } from '@/lib/i18n';

export function formatClock(value: string | Date, locale: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  const now = new Date();
  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  if (!sameDay) return formatDateTime(date, locale);
  return new Intl.DateTimeFormat(locale === 'ar' ? 'ar-SA' : 'en-US', {
    timeStyle: 'short',
  }).format(date);
}
